export function podcastListenPath(builderId, runId) {
  return `/listen/${encodeURIComponent(builderId)}/${encodeURIComponent(runId)}`;
}

export function podcastAudioPath(builderId, runId) {
  return `Podcasts/${builderId}/EN/builder/audio-generated/runs/${runId}/script_audio.mp3`;
}
